


const ShriRamreqbodyGen = (data) => {
  console.log(data, "....");

  let FinalReqbody = {
    Request: {},
  };
  let Proposal = {};

  Object.entries(data).map((field, index) => {
    
    switch (field[0]) {
      case "primaryDetails":
        Object.entries(field[1]).map((nesinnerField, index) => {
          if (
            nesinnerField[0] === "LifeAssured" ||
            nesinnerField[0] === "Address" ||
            nesinnerField[0] === "Family" ||
            nesinnerField[0] === "Plan" ||
            nesinnerField[0] === "PartnerRef" ||
            nesinnerField[0] === "Payment"
          ) {
            
            if (nesinnerField[0] === "Family") {
              nesinnerField[1].map((famItem,index) => {
                console.log("fam", famItem.DateofDeath);
                if (famItem.DateofDeath === "null") {
                  famItem.DateofDeath = "";
                  
                }
                if (famItem.DeathReason === "null") {
                  famItem.DeathReason = "";
                  
                }
                return null
              });
            }else if(nesinnerField[0] === "LifeAssured"){
              
              if(nesinnerField[1].NRI_Country === 'null'){
                nesinnerField[1]={
                  ...nesinnerField[1],
                  ['NRI_Country']:''
                }
              }
              if(nesinnerField[1].HusbandOccupation === 'null'){
                nesinnerField[1]={
                  ...nesinnerField[1],
                  ['HusbandOccupation']:''
                }
              }
            
            }

            Proposal[`${nesinnerField[0]}`] = nesinnerField[1];
          } else if (nesinnerField[0] === "Documents") {
            Proposal[`${nesinnerField[0]}`] = [];

            Object.entries(nesinnerField[1][0]).map((docField, ind) => {
              let obj = {};
              let docObj= {}
              let removeFlag = false;
              

              Object.entries(docField[1]).map(docProofEntry=>{
                
                if(docProofEntry[0] === "ProofImage"){
                    console.log('enty',docProofEntry[1],removeFlag)

                     if(docProofEntry[1] !== ''){ 
                      docObj["ProofImage"] =docProofEntry[1].value
                      //docField[1] = {...docField[1],["ProofImage"]:docProofEntry[1].value}
                      docField[1] = {...docField[1],...docObj}
                     
                      if (docField[0] === "IncomeProof") {
                        if (docField[1].ProofName === "") {
                          removeFlag = true;
                        }
                      }

                      if (!removeFlag) {
                        obj["ProofType"] = docField[0];
                        obj = { ...obj, ...docField[1] };
                        Proposal.Documents.push(obj);
                      }
                     }

                    
                }
                return null
              })
              return null
              
            });
          } else {
            if (typeof nesinnerField[1] === "object") {
              Proposal.Plan[`${nesinnerField[0]}`] = nesinnerField[1];
            } else {
              Proposal[`${nesinnerField[0]}`] = nesinnerField[1];
            }
          }
          return null
        });

        break;
      case "pedQuestionnPrimary":
        //console.log('quest',field[1])
        Object.entries(field[1]).map(questions=>{
          console.log('valalal',questions[0],typeof(questions[1]))

           if(typeof(questions[1]) === 'object'){
            Object.entries(questions[1]).map(queValues=>{
              //console.log('valalal',queValues)
              if(queValues[1] ==='null' && queValues[0] === "Reason" ){
                console.log('nulajah',queValues[0])
                
                field[1] ={
                  ...field[1],
                  [questions[0]]:{
                    ...questions[1],
                    ['Reason']:'',
                    ['Type']:'',
                  }
                }
              }
              /* if(queValues[1] ==='null' && queValues[0] === "Type"){
                console.log('nulajah',queValues)
                
                field[1] ={
                  ...field[1],
                  [questions[0]]:{
                    ...questions[1],
                    [queValues[0]]:''
                  }
                }
              } */
            })

          } 
        })
        console.log('jdj',field[1])
        Proposal["Questions"] = field[1];

        break;
      case "Proposer":
        
        Proposal["Proposer"] = field[1];

        break;
      case "nomineeDetails":
        field[1].map((nominee,index)=>{
          if(nominee.AppointeeFirstName === 'null'){
            nominee.AppointeeFirstName = ''
          } 
          if(nominee.AppointeeMiddleName === 'null'){
            nominee.AppointeeMiddleName = ''
          } 
          if(nominee.AppointeeLastName === 'null'){
            nominee.AppointeeLastName = ''
          }
          if(nominee.RelationshiptoNominee === 'null'){
            nominee.RelationshiptoNominee = ''
          }
        })
        Proposal["Nominee"] = field[1];
        break;
        default:
          break;
      }
      return null
  });
  console.log(Proposal, "....lll");
  FinalReqbody.Request["Proposal"] = Proposal;
  console.log('prop',Proposal)
  return FinalReqbody;
};
export default ShriRamreqbodyGen;
